<template>
  <BModal
    id="modal-download"
    title="BootstrapVue"
    centered
    hide-footer
    hide-header
    @hide="progress = null"
  >
    <div class="py-[56px] px-[32px]">
      <div class="space-y-[24px]">
        <div class="space-y-[16px] ">
          <div class="text-center text-[24px] font-semibold text-[#333]">
            Download Data Request Pickup
          </div>
          <div class="text-center text-[#333] text-[16px]">
            Download data semua permintaan pickup dari semua user di range waktu yang dipilih
          </div>
        </div>
        <div class="space-y-[8px]">
          <div class="text-[#333]">
            Pilih Rentang
          </div>
          <DateRangePicker
            ref="picker"
            v-model="dateRange"
            :locale-data="locale"
            :ranges="ranges"
            :opens="'center'"
            class="w-full"
            :date-format="dateFormat"
            @start-selection="onStartSelection"
          >
            <template
              v-slot:input="picker"
              style="min-width: 350px"
            >
              <div class="d-flex justify-content-between align-items-center w-100">
                <div class="mr-1">
                  <span
                    v-if="YEAR_MONTH_DAY(picker.startDate) === YEAR_MONTH_DAY(last2) && YEAR_MONTH_DAY(picker.endDate) === YEAR_MONTH_DAY(last2)"
                    style="color: #828282 !important"
                  >
                    Hari Kemarin
                  </span>
                  <span
                    v-else-if="YEAR_MONTH_DAY(picker.startDate) === YEAR_MONTH_DAY(last3) && YEAR_MONTH_DAY(picker.endDate) === YEAR_MONTH_DAY(today)"
                    style="color: #828282 !important"
                  >
                    3 Hari Terakhir
                  </span>
                  <span
                    v-else
                    style="color: #828282 !important"
                  >{{ SLASHED_DDMMYYYY(picker.startDate) }} - {{ SLASHED_DDMMYYYY(picker.endDate) }}</span>
                </div>
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/calendar.png"
                  alt="Komerce"
                >
              </div>
            </template>
          </DateRangePicker>
        </div>
        <BRow
          v-if="progress !== null"
          align-v="center"
        >
          <BCol cols="12">
            <div class="text-[#333] text-[12px]">
              Sedang memuat File
            </div>
          </BCol>
          <BCol>
            <BRow
              align-v="center"
            >
              <BCol cols="10">
                <BProgress
                  height="11px"
                  variant="success"
                  :value="progress"
                />
              </BCol>
              <BCol cols="2">
                <div class="text-[#333] text-[12px]">
                  {{ progress }}%
                </div>
              </BCol>
            </BRow>
          </BCol>
        </BRow>
        <BRow>
          <BCol cols="6">
            <BButton
              variant="outline-primary"
              class="w-full"
              @click="$bvModal.hide('modal-download')"
            >
              Batal
            </BButton>
          </BCol>
          <BCol cols="6">
            <BButton
              :variant="loadingDownload ? 'secondary' : 'primary'"
              class="w-full"
              :disabled="loadingDownload"
              @click="downloadMonitoringPickup"
            >
              Download
            </BButton>
          </BCol>
        </BRow>
      </div>
    </div>
  </BModal>
</template>

<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { DOWNLOAD_MONITORING_PICKUP } from '@/provider/url'
import { SLASHED_DDMMYYYY, YEAR_MONTH_DAY } from '@/libs/filterDate'
import { today, last2, last3 } from '@/store/helpers'
import { toastError, toastSuccess } from '@/libs/toastification'
import secureLocalStorage from '@/libs/secureLocalstorage'
import {
  dateRange, ranges, locale, MAX_DAYS_SELECTION, DATE_RANGE_MIN, DATE_RANGE_MAX,
} from './config'

export default {
  components: {
    DateRangePicker,
  },
  data() {
    return {
      progress: null,
      ekspedisi: secureLocalStorage.get('userData').mitras.owner,
      loadingDownload: false,
      dateRange: JSON.parse(JSON.stringify(dateRange)),
      ranges,
      locale,
      SLASHED_DDMMYYYY,
      YEAR_MONTH_DAY,
      last2,
      last3,
      today,
      MAX_DAYS_SELECTION,
      DATE_RANGE_MIN,
      DATE_RANGE_MAX,
      anchorDate: null,
    }
  },
  watch: {
    dateRange: {
      handler(newVal) {
        if (newVal.startDate && newVal.endDate) {
          this.anchorDate = null
          const startDate = moment(newVal.startDate)
          const endDate = moment(newVal.endDate)

          // Validasi: maksimal 3 hari
          const daysDiff = endDate.diff(startDate, 'days')
          if (daysDiff > this.MAX_DAYS_SELECTION - 1) {
            // Reset ke range sebelumnya atau default
            this.dateRange.endDate = moment(newVal.startDate).add(this.MAX_DAYS_SELECTION - 1, 'days').toDate()
            return
          }

          // Validasi: tidak boleh lebih dari 10 hari yang lalu
          if (startDate.toDate() < this.DATE_RANGE_MIN) {
            this.dateRange.startDate = this.DATE_RANGE_MIN
            return
          }
          this.progress = null
        }
      },
      deep: true,
    },
  },
  methods: {
    async downloadMonitoringPickup() {
      this.progress = 0
      this.loadingDownload = true
      const interval = setInterval(() => {
        if (this.progress < 90) this.progress += 2
      }, 100)
      await this.$http_new.get(DOWNLOAD_MONITORING_PICKUP, {
        params: {
          start_date: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
          end_date: moment(this.dateRange.endDate).format('YYYY-MM-DD'),
        },
      }).then(async res => {
        clearInterval(interval)
        await new Promise(resolve => {
          const fastInterval = setInterval(() => {
            if (this.progress >= 100) {
              clearInterval(fastInterval)
              resolve()
            } else {
              this.progress += 5
            }
          }, 10)
        })
        this.progress = 100
        this.loadingDownload = false
        const { data } = res.data

        const base64 = data
        const byteCharacters = atob(base64)
        const byteNumbers = new Array(byteCharacters.length)
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const blobURI = URL.createObjectURL(blob)
        const tempLink = document.createElement('a')
        tempLink.href = blobURI
        tempLink.setAttribute('download', `Request_Pickup_${this.ekspedisi}_${moment(this.dateRange.startDate).format('DD-MM-YYYY')}_${moment(this.dateRange.endDate).format('DD-MM-YYYY')}.xlsx`)
        tempLink.click()
        this.$bvModal.hide('modal-download')
      }).catch(err => {
        clearInterval(interval)
        this.loadingDownload = false
        toastError('Gagal mendownload data request pickup')
        this.progress = null
      })
    },
    onStartSelection(date) {
      this.anchorDate = date
    },
    dateFormat(classes, date) {
      // Disable tanggal di masa depan
      if (date.getTime() > this.DATE_RANGE_MAX.getTime()) {
        // eslint-disable-next-line no-param-reassign
        classes.disabled = true
        return classes
      }

      // Disable tanggal lebih dari 10 hari yang lalu
      const tenDaysAgo = new Date()
      tenDaysAgo.setDate(today.getDate() - 10)
      tenDaysAgo.setHours(0, 0, 0, 0)
      if (date.getTime() < tenDaysAgo.getTime()) {
        // eslint-disable-next-line no-param-reassign
        classes.disabled = true
        return classes
      }

      // Logic tambahan untuk custom range
      const { picker } = this.$refs
      if (picker && picker.in_selection) {
        const refDate = this.anchorDate || picker.start
        if (refDate) {
          const startDate = moment(refDate).startOf('day')
          const currentDate = moment(date).startOf('day')
          const daysDiff = Math.abs(currentDate.diff(startDate, 'days'))

          if (daysDiff > this.MAX_DAYS_SELECTION - 1) {
          // eslint-disable-next-line no-param-reassign
            classes.disabled = true
          }
        }
      }

      return classes
    },
  },
}
</script>
